/* Pebble Qore Ultra — landing page runtime. Plain JS, no framework, no build step. */
(function () {
  'use strict';

  function vis(el){
    if(!el) return false;
    var r=el.getBoundingClientRect();
    var vh=window.innerHeight||document.documentElement.clientHeight||800;
    return r.bottom>20 && r.top<vh-20 && (r.width>0||r.height>0);
  }
  function watchVis(el, onEnter, onLeave){
    if(!el) return function(){};
    var on=false, io=null, poll=null;
    function check(){
      var now=vis(el);
      if(now && !on){ on=true; if(onEnter) onEnter(); }
      else if(!now && on){ on=false; if(onLeave) onLeave(); }
    }
    if('IntersectionObserver' in window){
      try{
        io=new IntersectionObserver(function(){ check(); }, { threshold: [0, 0.01, 0.1], rootMargin: '200px 0px 200px 0px' });
        io.observe(el);
      }catch(e){ io=null; }
    }
    window.addEventListener('scroll', check, {passive:true});
    window.addEventListener('resize', check);
    window.addEventListener('orientationchange', check);
    window.addEventListener('touchmove', check, {passive:true});
    poll=setInterval(check, 400);
    setTimeout(check, 40);
    setTimeout(check, 350);
    setTimeout(check, 1200);
    return function(){ if(io) try{ io.disconnect(); }catch(e){} if(poll) clearInterval(poll); };
  }
  function armVideos(scope){
    var root=scope||document;
    root.querySelectorAll('video').forEach(function(v){
      v.muted=true;
      v.defaultMuted=true;
      v.playsInline=true;
      v.setAttribute('muted','');
      v.setAttribute('playsinline','');
      v.setAttribute('webkit-playsinline','');
      try{ var p=v.play(); if(p&&p.catch) p.catch(function(){}); }catch(e){}
    });
  }

  var vals = {};
  var app = null;

  function apply() {
    vals = app.renderVals ? app.renderVals() : {};
    document.querySelectorAll('[data-if]').forEach(function (el) {
      var k = el.getAttribute('data-if');
      if (!(k in vals)) return;
      el.style.display = vals[k] ? 'contents' : 'none';
    });
  }

  class DCLogic {
    constructor() { this.el = document.body; this.props = {}; this.state = {}; }
    setState(o) { Object.assign(this.state, typeof o === 'function' ? o(this.state) : o); apply(); }
    forceUpdate() { apply(); }
  }

  class Component extends DCLogic {
    state = { tab: 0, colour: 2 };
  
    /* --- sleep hypnogram + lock-screen insights ---------------------- */
    initSleep(root) {
      var sleepHost = document.getElementById('sleep');
      if (sleepHost && sleepHost.classList && sleepHost.classList.contains('nco-pack')) return;
      var lab = (sleepHost || root).querySelector('[data-lab]');
      if (!lab) return;
      var SEQ = [['awake',2],['light',5],['deep',8],['light',3],['rem',3],['light',4],['deep',9],
        ['light',4],['rem',5],['light',6],['deep',3],['light',5],['rem',6],['light',7],
        ['awake',1],['light',4],['rem',5],['light',5],['awake',1]];
      var blocks = [], ii = 0, k;
      for (k = 0; k < SEQ.length; k++) { blocks.push({ st: SEQ[k][0], i: ii, n: SEQ[k][1] }); ii += SEQ[k][1]; }
      var total = ii;
      var track = lab.querySelector('[data-track]');
      var svg = track && track.querySelector('svg');
      var clip = lab.querySelector('[data-clip]');
      var moon = lab.querySelector('[data-moon]');
      var box = lab.querySelector('[data-stagebox]');
      var sw = lab.querySelector('[data-sw]'), sd = lab.querySelector('[data-sd]'), sp = lab.querySelector('[data-sp]');
      var ring = lab.querySelector('[data-sleepring]'), scoreEl = lab.querySelector('[data-score]');
      var out = { hr: lab.querySelector('[data-hr]'), hrv: lab.querySelector('[data-hrv]'), br: lab.querySelector('[data-br]'), spo: lab.querySelector('[data-spo]') };
      if (!svg || !clip) return;
      var LV = { awake: 30, rem: 92, light: 148, deep: 206 };
      var ss = function (v) { return v * v * (3 - 2 * v); };
      var yAt = function (pos) {
        var k = -1;
        for (var j = 0; j < blocks.length; j++) { if (pos < blocks[j].i + blocks[j].n) { k = j; break; } }
        if (k < 0) k = blocks.length - 1;
        var b = blocks[k], nx = blocks[k + 1], end = b.i + b.n, T = 0.7;
        if (nx && pos > end - T) return LV[b.st] + (LV[nx.st] - LV[b.st]) * ss((pos - (end - T)) / T);
        return LV[b.st];
      };
      var pts = [];
      for (var x = 0; x <= 1000; x += 2.4) {
        pts.push(x.toFixed(1) + ' ' + yAt((x / 1000) * total).toFixed(1));
      }
      var d = 'M ' + pts.join(' L ');
      var fillD = d + ' L 1000 240 L 0 240 Z';
      var basePath = svg.querySelector('[data-basepath]');
      var fillPath = svg.querySelector('[data-fillpath]');
      var glowPath = svg.querySelector('[data-glowpath]');
      var strokePath = svg.querySelector('[data-strokepath]');
      if (basePath) basePath.setAttribute('d', d);
      if (fillPath) fillPath.setAttribute('d', fillD);
      if (glowPath) glowPath.setAttribute('d', d);
      if (strokePath) strokePath.setAttribute('d', d);
      function yOnPath(x) { return yAt((x / 1000) * total); }
      var COL = { awake: '#E6E1FB', rem: '#B8AEFF', light: '#9C97FF', deep: '#7D7AFF' };
      var NAME = { awake: 'Awake', rem: 'REM', light: 'Core', deep: 'Deep' };
      var DUR = { awake: ['20m', '5%'], rem: ['1h 35m', '22%'], light: ['3h 35m', '50%'], deep: ['1h 40m', '23%'] };
      var cur = null, lastSwap = 0, swT;
      function setStage(st) {
        if (st === cur) return;
        var now = performance.now();
        if (now - lastSwap < 1000 && cur !== null) return;
        cur = st; lastSwap = now;
        if (!box) return;
        box.style.opacity = '0'; box.style.filter = 'blur(10px)'; box.style.transform = 'translateY(8px)';
        clearTimeout(swT);
        swT = setTimeout(function () {
          if (sw) { sw.textContent = NAME[st]; sw.style.color = COL[st]; }
          if (sd) sd.textContent = DUR[st][0];
          if (sp) sp.textContent = DUR[st][1] + ' of the night';
          box.style.opacity = '1'; box.style.filter = 'blur(0)'; box.style.transform = 'translateY(0)';
        }, 380);
      }
      function show(t) {
        var pos = t * total;
        var bi = -1;
        for (var j = 0; j < blocks.length; j++) { if (pos < blocks[j].i + blocks[j].n) { bi = j; break; } }
        if (bi < 0) bi = blocks.length - 1;
        clip.setAttribute('width', (t * 1000).toFixed(1));
        if (moon) {
          var w = svg.clientWidth, hgt = svg.clientHeight;
          moon.style.left = (t * w).toFixed(1) + 'px';
          moon.style.top = (yOnPath(t * 1000) / 240 * hgt).toFixed(1) + 'px';
          moon.style.opacity = t > 0 && t < 1 ? '1' : '0';
        }
        setStage(blocks[bi].st);
      }
      function settle() {
        clip.setAttribute('width', '1000');
        if (moon) moon.style.opacity = '0';
        if (out.hr) out.hr.textContent = '54';
        if (out.hrv) out.hrv.textContent = '43';
        if (out.br) out.br.textContent = '14';
        if (out.spo) out.spo.textContent = '98';
      }
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (ring) ring.style.transition = 'stroke-dashoffset 1.8s cubic-bezier(.4,0,.2,1)';
      var sleepRaf;
      function fillRing() {
        var off = (314.16 * (1 - 0.67)).toFixed(1);
        if (ring) ring.style.strokeDashoffset = off;
        var rg = lab.querySelector('[data-ring-glow]'); if (rg) rg.style.strokeDashoffset = off;
        if (!scoreEl) return;
        if (false && reduce) { scoreEl.textContent = '67'; return; }
        var t0 = performance.now();
        function step(now) {
          var p = Math.min(1, (now - t0) / 1600);
          scoreEl.textContent = String(Math.round(67 * (1 - Math.pow(1 - p, 3))));
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      var CYCLE = 6200, DRAW = 4200, HOLD = 1400;
      function loop(t0) {
        function step(now) {
          var e = (now - t0) % CYCLE;
          if (e < DRAW) show(e / DRAW);
          else if (e < DRAW + HOLD) settle();
          else { clip.setAttribute('width', '0'); if (moon) moon.style.opacity = '0'; }
          sleepRaf = requestAnimationFrame(step);
        }
        sleepRaf = requestAnimationFrame(step);
      }
      function resetRing() {
        [ring, lab.querySelector('[data-ring-glow]')].forEach(function (r) {
          if (!r) return;
          r.style.transition = 'none'; r.style.strokeDashoffset = '314.16'; void r.getBoundingClientRect();
          r.style.transition = 'stroke-dashoffset 1.8s cubic-bezier(.4,0,.2,1)';
        });
        if (scoreEl) scoreEl.textContent = '0';
      }
      this.initLockScreen(root, reduce);
      if (false && reduce) { settle(); setStage('deep'); fillRing(); return; }
      watchVis(lab, function () {
        resetRing(); cur = null;
        requestAnimationFrame(function () { fillRing(); loop(performance.now()); });
      }, function () {
        cancelAnimationFrame(sleepRaf); resetRing(); clip.setAttribute('width', '0');
      });
    }

    initLockScreen(root, reduce) {
      var lock = (document.getElementById('sleep') || root).querySelector('[data-lock]');
      if (!lock) return;
      var rows = Array.prototype.slice.call(lock.querySelectorAll('[data-lock-n]'));
      function show(row) {
        row.style.gridTemplateRows = '1fr';
        var card = row.querySelector('[data-lock-card]');
        if (card) {
          card.style.opacity = '1'; card.style.transform = 'translateY(0) scale(1)';
          card.style.transition += ', box-shadow 1.2s ease';
          card.style.boxShadow = 'inset 0 1px 0 rgba(255,255,255,0.2), 0 0 0 1px rgba(198,188,255,0.55), 0 0 28px 2px rgba(155,135,240,0.55)';
          setTimeout(function () { card.style.boxShadow = 'inset 0 1px 0 rgba(255,255,255,0.16)'; }, 900);
        }
      }
      function hide(row) {
        row.style.gridTemplateRows = '0fr';
        var card = row.querySelector('[data-lock-card]');
        if (card) { card.style.opacity = '0'; card.style.transform = 'translateY(-10px) scale(0.94)'; }
      }
      if (false && reduce) { rows.forEach(show); return; }
      var order = rows.slice().reverse();
      var ts = [];
      function clear() { ts.forEach(clearTimeout); ts = []; }
      function run() {
        clear();
        order.forEach(function (row, i) { ts.push(setTimeout(function () { show(row); }, 500 + i * 850)); });
        var end = 500 + order.length * 850 + 3200;
        ts.push(setTimeout(function () { rows.forEach(hide); }, end));
        ts.push(setTimeout(run, end + 900));
      }
      watchVis(lock, function () { run(); }, function () { clear(); rows.forEach(hide); });
    }

    initLiveRun(root) {
      var host = document.getElementById('sport') || root;
      if (!host) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var get = function (k) { return host.querySelector('[data-live="' + k + '"]'); };
      var els = { dist: get('dist'), pace: get('pace'), hr: get('hr'), steps: get('steps') };
      if (!els.dist) return;
      var segs = [
        { km: 1.0, pace: 310, hr: 138, c: '#A5D64A' },
        { km: 1.0, pace: 292, hr: 146, c: '#22C55E' },
        { km: 1.0, pace: 324, hr: 152, c: '#F5C542' },
        { km: 1.0, pace: 298, hr: 149, c: '#A5D64A' },
        { km: 1.4, pace: 286, hr: 156, c: '#22C55E' }
      ];
      var CYCLE = 6.2, DRAW_END = 4.4, HOLD_END = 5.6;
      var mmss = function (s) { var m = Math.floor(s / 60), r = Math.round(s % 60); return m + ':' + (r < 10 ? '0' + r : r); };
      var paths = Array.prototype.slice.call(host.querySelectorAll('[data-seg]'));
      var marks = Array.prototype.slice.call(host.querySelectorAll('[data-km]'));
      var head = host.querySelector('[data-runhead]');
      var glow = host.querySelector('[data-runglow]');
      if (!paths.length) return;
      var lens = paths.map(function (p) { return p.getTotalLength(); });
      var total = lens.reduce(function (a, b) { return a + b; }, 0);
      var starts = []; lens.reduce(function (acc, l, i) { starts[i] = acc; return acc + l; }, 0);
      paths.forEach(function (p, i) { p.style.strokeDasharray = lens[i] + ' ' + lens[i]; p.style.strokeDashoffset = lens[i]; });
      var kmEdges = [0, 1, 2, 3, 4, 5.4];
      function paint(t) {
        var p, alive = 1;
        if (t <= DRAW_END) p = t / DRAW_END;
        else if (t <= HOLD_END) p = 1;
        else { p = 1; alive = 1 - (t - HOLD_END) / (CYCLE - HOLD_END); }
        var covered = total * p;
        paths.forEach(function (path, i) {
          var local = Math.min(1, Math.max(0, (covered - starts[i]) / lens[i]));
          path.style.strokeDashoffset = lens[i] * (1 - local);
          path.style.opacity = alive;
        });
        var active = null, ai = 0;
        for (var i = 0; i < paths.length; i++) { if (covered >= starts[i] && covered < starts[i] + lens[i]) { active = paths[i]; ai = i; break; } }
        if (!active) { active = paths[paths.length - 1]; ai = paths.length - 1; }
        var pt = active.getPointAtLength(Math.min(lens[ai], Math.max(0, covered - starts[ai])));
        if (head) { head.setAttribute('cx', pt.x); head.setAttribute('cy', pt.y); head.setAttribute('fill', segs[ai].c); head.style.opacity = (p < 1 ? 1 : 0) * alive; }
        if (glow) { glow.setAttribute('cx', pt.x); glow.setAttribute('cy', pt.y); glow.setAttribute('fill', segs[ai].c); glow.style.opacity = (p < 1 ? 0.22 : 0) * alive; }
        marks.forEach(function (g, i) { g.style.opacity = (covered >= Math.min(total - 1, starts[i] + lens[i] + 34) ? 1 : 0) * alive; });
        var localKm = lens[ai] ? (covered - starts[ai]) / lens[ai] : 1;
        var dist = kmEdges[ai] + (kmEdges[ai + 1] - kmEdges[ai]) * Math.min(1, Math.max(0, localKm));
        var secs = 0;
        for (var j = 0; j < ai; j++) secs += segs[j].km * segs[j].pace;
        secs += (dist - kmEdges[ai]) * segs[ai].pace;
        var prevHr = ai === 0 ? 96 : segs[ai - 1].hr;
        var hr = prevHr + (segs[ai].hr - prevHr) * Math.min(1, Math.max(0, localKm));
        var set = function (el, v) { if (el) el.textContent = v; };
        set(els.dist, dist.toFixed(2));
        set(els.pace, dist > 0.02 ? mmss(secs / dist) : '0:00');
        set(els.hr, String(Math.round(hr)));
        set(els.steps, Math.round(secs / 60 * 172).toLocaleString());
      }
      if (false && reduce) { paint(DRAW_END); return; }
      var raf = 0;
      paint(0);
      function remesure(){
        lens = paths.map(function (p) { try { return p.getTotalLength(); } catch (e) { return 0; } });
        total = lens.reduce(function (a, b) { return a + b; }, 0);
        starts = []; lens.reduce(function (acc, l, i) { starts[i] = acc; return acc + l; }, 0);
        paths.forEach(function (p, i) { p.style.strokeDasharray = lens[i] + ' ' + lens[i]; p.style.strokeDashoffset = lens[i]; });
      }
      if (total < 2) setTimeout(remesure, 250);
      watchVis(host, function () {
        cancelAnimationFrame(raf);
        remesure();
        var t0 = performance.now();
        var tick = function (now) { try { paint(((now - t0) / 1000) % CYCLE); } catch (e) {} raf = requestAnimationFrame(tick); };
        raf = requestAnimationFrame(tick);
      }, function () { cancelAnimationFrame(raf); try { paint(0); } catch (e) {} });
    }

    initFamily(root) {
      const list = (document.getElementById('family') || root).querySelector('[data-fam-list]');
      if (!list) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rows = Array.from(list.querySelectorAll('[data-fam-row]')).map(function (el, i) {
        return { el: el, target: parseFloat(el.getAttribute('data-fam-target')),
          countEl: el.querySelector('[data-fam-count]'), barEl: el.querySelector('[data-fam-bar]'), order: i, val: 0 };
      });
      if (!rows.length) return;
      const maxTarget = Math.max.apply(null, rows.map(function (r) { return r.target; }));
      const fmt = function (n) { return Math.round(n).toLocaleString('en-US'); };
      const ease = function (t) { return 1 - Math.pow(1 - t, 3); };
      let lastKey = rows.map(function (r) { return r.order; }).join(','), lastFlip = 0;
      const applyOrder = function (force) {
        const now = performance.now();
        const sorted = rows.slice().sort(function (a, b) { return b.val - a.val; });
        const key = sorted.map(function (r) { return rows.indexOf(r); }).join(',');
        if (key === lastKey) return;
        if (!force && now - lastFlip < 420) return;
        lastKey = key; lastFlip = now;
        const before = rows.map(function (r) { return r.el.getBoundingClientRect().top; });
        sorted.forEach(function (r, i) { r.order = i; r.el.style.order = String(i); });
        rows.forEach(function (r, i) {
          const after = r.el.getBoundingClientRect().top;
          const dy = before[i] - after;
          if (Math.abs(dy) > 0.5) {
            r.el.style.transition = 'none';
            r.el.style.transform = 'translateY(' + dy + 'px)';
            requestAnimationFrame(function () {
              r.el.style.transition = 'transform .5s cubic-bezier(.2,.8,.2,1)';
              r.el.style.transform = '';
            });
          }
        });
      };
      const run = function () {
        const t0 = performance.now();
        const specs = [
          { row: rows[0], delay: 0, dur: 1300 },
          { row: rows[1], delay: 150, dur: 1500 },
          { row: rows[2], delay: 650, dur: 2000 }
        ];
        const step = function (now) {
          let doneAll = true;
          specs.forEach(function (s) {
            if (!s.row) return;
            const e = now - t0 - s.delay;
            if (e < 0) { doneAll = false; return; }
            const p = Math.min(1, e / s.dur);
            if (p < 1) doneAll = false;
            s.row.val = s.row.target * ease(p);
            if (s.row.countEl) s.row.countEl.textContent = fmt(s.row.val);
            if (s.row.barEl) s.row.barEl.style.width = (s.row.val / maxTarget * 100).toFixed(1) + '%';
          });
          applyOrder(false);
          if (!doneAll) requestAnimationFrame(step);
          else applyOrder(true);
        };
        requestAnimationFrame(step);
      };
      if (false && reduce) {
        rows.forEach(function (r) {
          r.val = r.target;
          if (r.countEl) r.countEl.textContent = fmt(r.target);
          if (r.barEl) r.barEl.style.width = (r.target / maxTarget * 100).toFixed(1) + '%';
        });
        applyOrder(true);
        return;
      }
      var famOnce=false;
      watchVis(list, function () { if (famOnce) return; famOnce=true; run(); });
    }
  
    componentDidMount() {
      const root = this.el || document;
      const q = (sel) => Array.from(root.querySelectorAll(sel));
      this._cleanups = [];
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
      const links = root.querySelector('[data-nav-links]');
      this._fit = null;
  
      const revealEls = q('[data-r]');
      const imgEls = q('[data-i]');
      const reveal = ('IntersectionObserver' in window) ? new IntersectionObserver((es) => {
        es.forEach(e => { if (e.isIntersecting) { e.target.setAttribute('data-reveal','in'); reveal.unobserve(e.target); } });
      }, { threshold: 0.01, rootMargin: '120px 0px 80px 0px' }) : null;
      revealEls.forEach((el, i) => {
        el.setAttribute('data-reveal','pending');
        el.style.transitionDelay = ((i % 3) * 100) + 'ms';
        if (reveal) reveal.observe(el);
      });
      const imgs = ('IntersectionObserver' in window) ? new IntersectionObserver((es) => {
        es.forEach(e => { if (e.isIntersecting) { e.target.setAttribute('data-img','in'); imgs.unobserve(e.target); } });
      }, { threshold: 0.01, rootMargin: '120px 0px' }) : null;
      imgEls.forEach(el => { el.setAttribute('data-img','pending'); if (imgs) imgs.observe(el); });
      function sweepReveal(){
        var still=false;
        revealEls.forEach(function(el){
          if(el.getAttribute('data-reveal')!=='in'){
            if(vis(el)) el.setAttribute('data-reveal','in'); else still=true;
          }
        });
        imgEls.forEach(function(el){
          if(el.getAttribute('data-img')!=='in'){
            if(vis(el)) el.setAttribute('data-img','in'); else still=true;
          }
        });
        if(!still){ window.removeEventListener('scroll', sweepReveal); clearInterval(revPoll); }
      }
      window.addEventListener('scroll', sweepReveal, {passive:true});
      window.addEventListener('resize', sweepReveal);
      window.addEventListener('touchstart', sweepReveal, {passive:true});
      var revPoll=setInterval(sweepReveal, 400);
      setTimeout(sweepReveal, 50);
      setTimeout(sweepReveal, 600);
  
      const ease = (t) => 1 - Math.pow(1 - t, 3);
      const run = (el, fn2, dur) => {
        const t0 = performance.now();
        const step = (t) => { const p = Math.min(1, (t - t0) / dur); fn2(ease(p)); if (p < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      };
      function fireAnim(el) {
          if (!el || el.getAttribute('data-anim-done') === '1') return;
          el.setAttribute('data-anim-done','1');
          if (el.hasAttribute('data-count')) {
            const raw = el.getAttribute('data-count');
            const end = parseFloat(raw);
            const dec = (raw.split('.')[1] || '').length;
            const tail = el.querySelector('span');
            run(el, p => {
              const v = end * p;
              const txt = end >= 10000 ? Math.round(v).toLocaleString('en-IN') : v.toFixed(dec);
              if (tail) el.childNodes[0].nodeValue = txt; else el.textContent = txt;
            }, 1500);
          }
          if (el.hasAttribute('data-ring')) {
            const C = 314, off = C - C * parseFloat(el.getAttribute('data-ring')) / 100;
            el.style.strokeDashoffset = C;
            run(el, p => { el.style.strokeDashoffset = C - (C - off) * p; }, 1600);
          }
          if (el.hasAttribute('data-bar')) {
            const pc = parseFloat(el.getAttribute('data-bar'));
            el.style.width = '0%';
            run(el, p => { el.style.width = (pc * p) + '%'; }, 1300);
          }
          if (el.hasAttribute('data-grow')) {
            const h = el.style.height;
            el.style.transformOrigin = 'bottom';
            el.style.transform = 'scaleY(0)';
            el.style.height = h;
            run(el, p => { el.style.transform = 'scaleY(' + p + ')'; }, 1100);
          }
      }
      const animEls = q('[data-count],[data-ring],[data-bar],[data-grow]');
      const anim = ('IntersectionObserver' in window) ? new IntersectionObserver((es) => {
        es.forEach(e => { if (e.isIntersecting) fireAnim(e.target); });
      }, { threshold: 0.01, rootMargin: '80px 0px' }) : null;
      animEls.forEach(el => {
        if (anim) anim.observe(el);
        watchVis(el, function(){ fireAnim(el); });
      });
  
      this._obs = [reveal, imgs, anim];
      this.polish(root, q);
      this.initSleep(root);
      this.initLiveRun(root);
      this.initFamily(root);
    }
  
    polish(root, q) {
      const host = root.firstElementChild || root;
      const on = (t, ev, fn, o) => { t.addEventListener(ev, fn, o); this._cleanups.push(() => t.removeEventListener(ev, fn, o)); };
  
      const bar = document.createElement('div');
      bar.setAttribute('aria-hidden', 'true');
      bar.style.cssText = 'position:fixed;top:0;left:0;height:2px;width:0%;z-index:200;background:linear-gradient(90deg,#A5D64A,#22C55E);transition:width .12s linear;pointer-events:none;';
      host.appendChild(bar);
  
      const navBar = root.querySelector('[data-navbar]');
      const heroImg = root.querySelector('[data-hero-img]');
      const self = this;
      this._parallax = Array.from(root.querySelectorAll('[data-parallax]')).map(el => ({
        el, wrap: el.closest('[data-parallax-wrap]') || el.parentElement,
        speed: parseFloat(el.getAttribute('data-parallax')) || 0.2
      }));
      let lastY = 0, ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const y = window.scrollY || document.documentElement.scrollTop;
          const max = document.documentElement.scrollHeight - window.innerHeight;
          bar.style.width = (max > 0 ? (y / max) * 100 : 0) + '%';
          if (navBar) {
            navBar.classList.toggle('is-scrolled', y > 12);
          }
          self._parallax.forEach(p => {
            const r = p.wrap.getBoundingClientRect();
            if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
            const mid = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
            p.el.style.transform = 'translate3d(0,' + (mid * p.speed * r.height).toFixed(1) + 'px,0)';
          });
          if (heroImg && y < 1000) heroImg.style.transform = 'translate3d(0,' + (y * 0.1) + 'px,0) scale(' + (1 + y * 0.00007) + ')';
          lastY = y;
          ticking = false;
        });
      };
      on(window, 'scroll', onScroll, { passive: true });
      onScroll();
  
      const isCard = (el) => {
        const cs = getComputedStyle(el);
        if (el.hasAttribute('data-flat')) return false;
        return (parseFloat(cs.borderRadius) || 0) >= 18 && el.offsetHeight > 130 && cs.animationName === 'none' && !el.querySelector('[data-r]');
      };
      q('[data-r]').filter(isCard).forEach(card => {
        card.style.transition = 'opacity 1s cubic-bezier(.16,1,.3,1), filter 1s cubic-bezier(.16,1,.3,1), transform .7s cubic-bezier(.16,1,.3,1), box-shadow .7s cubic-bezier(.16,1,.3,1)';
        card.style.willChange = 'transform';
        let raf = 0;
        on(card, 'mousemove', (e) => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = 0;
            const b = card.getBoundingClientRect();
            const px = (e.clientX - b.left) / b.width - 0.5;
            const py = (e.clientY - b.top) / b.height - 0.5;
            card.style.transform = 'perspective(1100px) rotateX(' + (-py * 2.8).toFixed(2) + 'deg) rotateY(' + (px * 3.4).toFixed(2) + 'deg) translate3d(0,-6px,0)';
          });
        });
        on(card, 'mouseenter', () => { card.style.boxShadow = '0 36px 70px -34px rgba(10,46,69,0.4)'; });
        on(card, 'mouseleave', () => { card.style.transform = 'none'; card.style.boxShadow = ''; });
      });
  
      q('a').filter(a => getComputedStyle(a).borderRadius === '999px').forEach(btn => {
        btn.style.position = 'relative';
        btn.style.overflow = 'hidden';
        btn.style.transition = 'transform .45s cubic-bezier(.16,1,.3,1), background .35s ease, border-color .35s ease, color .35s ease';
        const sheen = document.createElement('span');
        sheen.setAttribute('aria-hidden', 'true');
        sheen.style.cssText = 'position:absolute;top:0;left:0;width:45%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,0.4),transparent);transform:translateX(-120%) skewX(-18deg);pointer-events:none;';
        btn.appendChild(sheen);
        on(btn, 'mousemove', (e) => {
          const b = btn.getBoundingClientRect();
          const dx = (e.clientX - (b.left + b.width / 2)) / b.width;
          const dy = (e.clientY - (b.top + b.height / 2)) / b.height;
          btn.style.transform = 'translate(' + (dx * 9).toFixed(1) + 'px,' + (dy * 5).toFixed(1) + 'px)';
        });
        on(btn, 'mouseenter', () => { sheen.style.animation = 'none'; void sheen.offsetWidth; sheen.style.animation = 'om-sheen .95s ease-out'; });
        on(btn, 'mouseleave', () => { btn.style.transform = 'none'; });
      });
    }
  
  
    componentWillUnmount() {
      clearTimeout(this._ct);
      (this._obs || []).forEach(o => o.disconnect());
      (this._cleanups || []).forEach(f => f());
      if (this._fit) window.removeEventListener('resize', this._fit);
    }
  
    renderVals() {
      const t = this.state.tab || 0;
      const setTab = (i) => () => this.setState({ tab: i });
      const colours = [
        { name: 'Black', src: 'img/p-black-front.png' },
        { name: 'Blue', src: 'img/p-navy-front.png' },
        { name: 'Beige', src: 'img/p-gold-front.png' }
      ];
      const c = this.state.colour || 0;
      const setC = (i) => () => this.setState({ colour: i });
      return {
        pick0: setTab(0), pick1: setTab(1), pick2: setTab(2),
        isSleep: t === 0, isReadiness: t === 1, isActivity: t === 2,
        t0on: t === 0, t1on: t === 1, t2on: t === 2,
        t0off: t !== 0, t1off: t !== 1, t2off: t !== 2,
        c0on: c === 0, c1on: c === 1, c2on: c === 2,
        c0off: c !== 0, c1off: c !== 1, c2off: c !== 2,
        colourName: colours[c].name,
        prevColour: () => this.setState({ colour: (c + 2) % 3 }),
        nextColour: () => this.setState({ colour: (c + 1) % 3 }),
        pickC0: setC(0), pickC1: setC(1), pickC2: setC(2)
      };
    }
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-act]');
    if (!el) return;
    var fn = vals[el.getAttribute('data-act')];
    if (typeof fn === 'function') fn();
  });

  function initScores() {
    var sec = document.querySelector('#scores');
    if (!sec || sec.hasAttribute('data-sc-pack')) return;
    var desk = sec.querySelector('[data-sc-desk]');
    var qa = function (a) { return Array.from(sec.querySelectorAll('[' + a + ']')); };
    var frames = qa('data-sc-frame'), copies = qa('data-sc-copy'), bars = qa('data-sc-bar'), cards = qa('data-sc-card');
    var clamp = function (v) { return Math.min(1, Math.max(0, v)); };
    var smooth = function (v) { return v * v * (3 - 2 * v); };
    var raf = 0;
    var sizeMob = function () {
      var stage = sec.querySelector('.qu-sc-stack__stage');
      var card = cards[0];
      if (!stage || !card || !card.offsetParent) return;
      var h = card.offsetHeight;
      if (h > 40) stage.style.setProperty('--sc-h', h + 'px');
    };
    var update = function () {
      raf = 0;
      var vh = window.innerHeight;
      if (desk && desk.offsetParent) {
        var r = desk.getBoundingClientRect();
        var p = clamp(-r.top / Math.max(1, r.height - vh));
        var f = p * 3, idx = Math.min(2, Math.floor(f)), local = p >= 1 ? 1 : f - idx;
        var c = idx + smooth(clamp((local - 0.75) / 0.25)) * (idx < 2 ? 1 : 0);
        frames.forEach(function (fr, i) {
          var k = smooth(clamp(1 - Math.abs(c - i)));
          fr.style.transform = 'scale(' + (0.92 + 0.08 * k).toFixed(4) + ')';
          fr.style.filter = 'brightness(' + (0.42 + 0.58 * k).toFixed(3) + ') saturate(' + (0.6 + 0.4 * k).toFixed(3) + ')';
          if (copies[i]) copies[i].style.opacity = (0.35 + 0.65 * k).toFixed(3);
        });
        bars.forEach(function (bb, i) { bb.style.width = (i < idx ? 100 : i === idx ? local * 100 : 0).toFixed(1) + '%'; });
      }
      if (cards.length && cards[0].offsetParent) {
        var wrap = sec.querySelector('[data-sc-mob]');
        var wr = wrap ? wrap.getBoundingClientRect() : null;
        var p = wr ? clamp(-wr.top / Math.max(1, wr.height - vh)) : 0;
        var n = cards.length;
        var t = p * Math.max(1, n - 1);
        cards.forEach(function (cd, i) {
          var d = t - i;
          var y, s, o;
          if (d < -1) {
            y = 110; s = 1; o = 0;
          } else if (d < 0) {
            y = -d * 110;
            s = 1;
            o = 1;
          } else {
            var k = Math.min(1, d);
            s = 1 - 0.08 * k;
            y = -3 * k;
            o = 1 - k;
          }
          cd.style.transform = 'translate3d(0,' + y.toFixed(2) + '%,0) scale(' + s.toFixed(4) + ')';
          cd.style.opacity = String(o.toFixed(3));
          cd.style.visibility = o < 0.02 ? 'hidden' : 'visible';
          cd.style.filter = 'none';
          cd.style.zIndex = String(i + 1);
        });
      }
    };
    var onScroll = function () { if (!raf) raf = requestAnimationFrame(update); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { sizeMob(); onScroll(); });
    cards.forEach(function (cd) {
      var img = cd.querySelector('img');
      if (img) {
        if (img.complete) sizeMob();
        else img.addEventListener('load', sizeMob);
      }
    });
    sizeMob();
    update();
  }

  function boot() {
    app = new Component();
    apply();
    armVideos(document);
    app.componentDidMount();

  function initCompare() {
    var root = document.querySelector('.om-cmp-section');
    if (!root) return;
    var dataEl = document.getElementById('om-cmp-data');
    var CMP = [
      { t: 'Heart & vitals', s: 'Measured around the clock.', rows: [
        ['Heart Rate 24x7', 1, 1], ['HRV 24x7', 1, 1], ['Blood Oxygen 24x7', 1, 1],
        ['Stress Monitoring 24x7', 1, 1], ['Respiratory Rate', 1, 1], ['Body Temperature', 0, 1]
      ]},
      { t: 'Sleep & recovery', s: 'How well you rest and bounce back.', rows: [
        ['Sleep', '24x7', 1], ['Body Energy', 1, 1], ['Menstrual', 1, 1],
        ['Recovery Mode', 0, 1], ['AI Health Score', 0, 1]
      ]},
      { t: 'Fitness', s: 'Every session, tracked on your wrist.', rows: [
        ['Activity 24x7', 1, 1], ['VO2 Max', 1, 1], ['GPS Sports', 1, 0],
        ['Auto Sports Detection', 1, 1], ['Sports Record', 1, 1], ['Total Calories Consumption', 1, 1]
      ]},
      { t: 'Smart features', s: 'Insights and the apps you use.', rows: [
        ['Body Age', 1, 0], ['Fitness Age', 1, 0], ['One-key Measurement', 1, 0],
        ['Apple Health / Health Connect', 1, 1], ['AI Notes & Summaries', 0, 1], ['Family Ranking', 0, 0]
      ]}
    ];
    if (dataEl) {
      try {
        var parsed = JSON.parse(dataEl.textContent || '{}');
        if (parsed.tabs && parsed.tabs.length) CMP = parsed.tabs;
      } catch (e) {}
    }
    var tabs = root.querySelectorAll('.om-cmp-tab');
    var rowsEl = root.querySelector('[data-om-cmp-rows]');
    var titleEl = root.querySelector('[data-om-cmp-title]');
    var subEl = root.querySelector('[data-om-cmp-sub]');
    if (!rowsEl) return;
    var current = 0, switching = false;
    function cell(v) { return { y: v === 1, n: v === 0, t: typeof v === 'string' ? v : '' }; }
    function svgCheck(color) {
      return '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="' + color + '" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>';
    }
    function svgCross(color) {
      return '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="' + color + '" stroke-width="3" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
    }
    function renderRows(idx) {
      var data = CMP[idx];
      if (!data) return;
      var html = '';
      data.rows.forEach(function (r) {
        var q = cell(r[1]), o = cell(r[2]);
        html += '<div class="om-cmp-row">';
        html += '<div class="om-cmp-row-label">' + r[0] + '</div>';
        html += '<div class="om-cmp-row-q">';
        if (q.y) html += '<span class="om-cmp-badge-yes" aria-label="Yes">' + svgCheck('#0B1A07') + '</span>';
        if (q.n) html += '<span class="om-cmp-badge-no" aria-label="Not included"></span>';
        if (q.t) html += '<span>' + q.t + '</span>';
        html += '</div>';
        html += '<div class="om-cmp-row-o">';
        if (o.y) html += '<span class="om-cmp-badge-yes-other" aria-label="Yes">' + svgCheck('#9AA5AF') + '</span>';
        if (o.n) html += '<span class="om-cmp-badge-no-other" aria-label="Not included">' + svgCross('#56606A') + '</span>';
        if (o.t) html += '<span>' + o.t + '</span>';
        html += '</div></div>';
      });
      rowsEl.innerHTML = html;
      if (titleEl) titleEl.textContent = data.t;
      if (subEl) subEl.textContent = data.s;
    }
    function pick(idx) {
      if (idx === current || switching) return;
      switching = true;
      rowsEl.classList.add('is-fade');
      if (titleEl) titleEl.style.opacity = 0;
      if (subEl) subEl.style.opacity = 0;
      setTimeout(function () {
        current = idx;
        renderRows(idx);
        tabs.forEach(function (t, i) { t.classList.toggle('is-on', i === idx); });
        rowsEl.classList.remove('is-fade');
        if (titleEl) titleEl.style.opacity = 1;
        if (subEl) subEl.style.opacity = 1;
        switching = false;
      }, 180);
    }
    tabs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { pick(i); });
    });
    if (!rowsEl.children.length) renderRows(0);
  }

    initScores();
    initCompare();
    document.addEventListener('touchstart', function(){ armVideos(document); }, {passive:true});
    document.addEventListener('click', function(){ armVideos(document); });
    window.addEventListener('pageshow', function(){ armVideos(document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
